var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HostUri = void 0;
var _expoConstants = _interopRequireDefault(require("expo-constants"));
var _Constants$expoConfig, _Constants$expoConfig2, _Constants$expoConfig3;
var HostUri = exports.HostUri = _expoConstants["default"] == null ? void 0 : (_Constants$expoConfig = _expoConstants["default"].expoConfig) == null ? void 0 : (_Constants$expoConfig2 = _Constants$expoConfig.hostUri) == null ? void 0 : (_Constants$expoConfig3 = _Constants$expoConfig2.split(":")) == null ? void 0 : _Constants$expoConfig3.shift();
if (HostUri) {
  exports.HostUri = HostUri = 'http://' + HostUri;
}